<template>
  <div class="">
    <p class="border-b border-solid border-beige3 px-4 pb-4 text-[16px] md:text-[17px]">Location Details</p>
    <div class="max-h-[70vh] max-w-[640px] overflow-y-auto p-4 md:px-10 md:py-4">
      <!-- eslint-disable-next-line vue/no-v-html -->
      <span class="w-full break-words md:text-[16px]" v-html="convertNewlinesToBreaks(venueDetail)"></span>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { convertNewlinesToBreaks } from '@/utils/stringUtils';

interface Props {
  venueDetail: string;
}

defineProps<Props>();
</script>
